import Typography from "antd/lib/typography";

import { Route } from "@sol/routing";
import { Bell02 } from "@sol/uikit/core/icons/Alerts/Bell02";
import { Logout } from "@sol/uikit/core/icons/Logout";
import { Profile } from "@sol/uikit/core/icons/Profile";
import { Settings } from "@sol/uikit/core/icons/Settings";

import { getLink, MenuItem } from "./getLink";
import styles from "../styles/dropdownItem.module.css";

/**
 * Resolves the user dropdown menu items (profile, settings, logout).
 * These are not role-dependent so they don't need the widget pattern.
 */
export const getDropdownItems = ({ t, logout }: { t: (key: string) => string; logout: () => void }): MenuItem[] => {
    return [
        getLink({
            "data-cy": "menu-dropdown-profile",
            href: Route.PROFILE,
            label: (
                <Typography.Text className="inline-flex items-center gap-1 text-ant-sm">
                    {t("component.Navigation.Menu.dropdownMenu.items.profile")}
                </Typography.Text>
            ),
            icon: <Profile />,
            className: styles.dropdownItem,
        }),
        getLink({
            "data-cy": "menu-dropdown-settings",
            label: (
                <Typography className="inline-flex items-center gap-1 text-ant-sm">
                    {t("component.Navigation.Menu.dropdownMenu.items.settings")}
                </Typography>
            ),
            href: Route.PROFILE_EDIT,
            icon: <Settings />,
            className: styles.dropdownItem,
        }),
        getLink({
            "data-cy": "menu-dropdown-announcements",
            href: Route.ANNOUNCEMENTS,
            label: (
                <Typography.Text className="inline-flex items-center gap-1 text-ant-sm">
                    {t("component.Navigation.Menu.dropdownMenu.items.announcements")}
                </Typography.Text>
            ),
            icon: <Bell02 size={20} />,
            className: styles.dropdownItem,
        }),
        {
            label: (
                <button
                    tabIndex={-1}
                    type="button"
                    className="inline-flex items-center gap-1 after:absolute after:inset-0 after:[content:'']"
                    onClick={logout}
                    data-cy="logout"
                >
                    <Typography className="text-ant-sm">
                        {t("component.Navigation.Menu.dropdownMenu.items.logout")}
                    </Typography>
                </button>
            ),
            icon: <Logout stroke="transparent-base" />,
            key: "logout",
            className: styles.dropdownItem,
        },
    ];
};
